import React from 'react';
import { connect } from 'react-redux';
import i18n from '../../i18n/i18n';
import {
    TextField, Button, Grid, IconButton,
    Dialog, DialogContent, DialogTitle, Card
} from '@material-ui/core';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
    addSociety, getStates,
    setInitialState
} from '../../actions/AdministrationActions';
import { DatePicker } from 'material-ui-pickers';
import { getLocalGov } from '../../actions/FarmRegistarActions';
import { getUser } from '../../utils/CommonFunctions';
import moment from 'moment';
const styles = {
    card: {
        padding: '10px',
        width: '100%',
        margin: '10px',
        display: 'flex',
        flexWrap: 'wrap',
    },
}
export class AddSociety extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            societyObj: {}
        };
    }

    async componentDidMount() {
        const { getStates, getLocalGov } = this.props;
        getStates();
        let user = await getUser();
        if (user) {
            getLocalGov(user.id_opstina);
            const { societyObj } = this.state;
            let obj = Object.assign({}, societyObj);
            obj.id_opstina = user.id_opstina;
            obj.id_opstina_korisnik = user.id_opstina;
            this.setState({
                societyObj: obj
            })
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.societyPostingFailed === true) {
            toast.error(i18n.t('Something went wrong, please try again!'), {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                draggablePercent: 80
            });
            this.props.setInitialState('societyPostingFailed');
        }
    }

    handleChangeValue = name => event => {
        const { societyObj } = this.state;
        let obj = Object.assign({}, societyObj);
        obj[name] = event.target.value;
        this.setState({ societyObj: obj });
    };

    addSociety() {
        const { societyObj } = this.state;
        const { addSociety } = this.props;
        if (societyObj.kontakt_mejl &&
            societyObj.id_katastarska_opstina &&
            societyObj.id_opstina &&
            societyObj.naziv &&
            societyObj.rc_number &&
            societyObj.kontakt_mobilni &&
            societyObj.boa_number &&
            societyObj.bvn &&
            societyObj.ulica_i_broj &&
            societyObj.ulica_i_broj_korisnik &&
            societyObj.id_katastarska_opstina_korisnik &&
            societyObj.id_opstina_korisnik &&
            societyObj.commercial_activity &&
            societyObj.num_years_business &&
            societyObj.incorporation_date &&
            societyObj.ime &&
            societyObj.prezime &&
            societyObj.username &&
            societyObj.password) {
            addSociety(
                societyObj
            )
        } else {
            toast.error(i18n.t('Please enter all required fields!'), {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                draggablePercent: 80
            });
        }
    }

    handleDateChange = name => date => {
        const { societyObj } = this.state;
        let obj = Object.assign({}, societyObj);
        obj[name] = moment(date, 'DD.MM.YYYY').format('DD.MM.YYYY');
        this.setState({ societyObj: obj });
    }


    renderLabel = (date) => {
        if (date.isValid()) {
            return date.format('DD.MM.YYYY');
        } else {
            return '';
        }
    }


    render() {
        const { localGoverments, localGovermentsFetching, states, statesFetching, add, handleClose } = this.props;
        const { societyObj } = this.state;
        let localGovermentsArray = [];
        if (localGoverments && !localGovermentsFetching) {
            localGovermentsArray = localGoverments.map((s, i) => {
                return <option key={s.id} value={s.id}>{s.naziv}</option>
            });
        }
        let statesArray = [];
        if (states && !statesFetching) {
            statesArray = states.map((s, i) => {
                return <option key={s.id} value={s.id}>{s.naziv}</option>
            });
        }

        return (
            <div style={{ padding: 20 }}>
                <Dialog
                    open={add}
                    onClose={handleClose}
                    disableBackdropClick
                    maxWidth="sm"
                    aria-labelledby="responsive-dialog-title"
                >
                    <DialogTitle disableTypography={true} className="responsive-dialog-title">{i18n.t('Add society')}
                        <IconButton onClick={handleClose}>
                            <span className="icon-cancel-circle closeIcon" />
                        </IconButton>
                    </DialogTitle>

                    <DialogContent>
                        <form id="add-zonal">
                            <Grid container justify="space-between" alignContent="space-between" spacing={16} style={{ paddingTop: '20px', paddingBottom: '20px' }}>
                                <TextField
                                    label={i18n.t('First name')}
                                    required
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    value={societyObj.ime}
                                    style={{ width: '256px', marginTop: '10px', marginBottom: '10px' }}
                                    onChange={this.handleChangeValue('ime')}
                                />
                                <TextField
                                    label={i18n.t('Last name')}
                                    required
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    value={societyObj.prezime}
                                    style={{ width: '256px', marginTop: '10px', marginBottom: '10px' }}
                                    onChange={this.handleChangeValue('prezime')}
                                />
                                <TextField
                                    label={i18n.t('Username')}
                                    required
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    value={societyObj.username}
                                    style={{ width: '256px', marginTop: '10px', marginBottom: '10px' }}
                                    onChange={this.handleChangeValue('username')}
                                />
                                <TextField
                                    label={i18n.t('Password')}
                                    type="password"
                                    required
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    style={{ width: '256px', marginTop: '10px', marginBottom: '10px' }}
                                    onChange={this.handleChangeValue('password')}
                                />
                                <TextField
                                    label={i18n.t('Cooperative name')}
                                    required
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    value={societyObj.naziv}
                                    style={{ width: '256px', marginTop: '10px', marginBottom: '10px' }}
                                    onChange={this.handleChangeValue('naziv')}
                                />
                                <TextField
                                    label={i18n.t('Name of Cluster Head Reg Number')}
                                    required
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    value={societyObj.rc_number}
                                    style={{ width: '260px', marginTop: '10px', marginBottom: '10px' }}
                                    onChange={this.handleChangeValue('rc_number')}
                                />
                                <TextField
                                    label={i18n.t('Mobile Number')}
                                    required
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    value={societyObj.kontakt_mobilni}
                                    style={{ width: '256px', marginTop: '10px', marginBottom: '10px' }}
                                    onChange={this.handleChangeValue('kontakt_mobilni')}
                                />
                                <TextField
                                    label={i18n.t('BOA Account Number')}
                                    required
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    type="number"
                                    value={societyObj.boa_number}
                                    style={{ width: '256px', marginTop: '10px', marginBottom: '10px' }}
                                    onChange={this.handleChangeValue('boa_number')}
                                />
                                <TextField
                                    label={i18n.t('Bank Verification No')}
                                    required
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    type="number"
                                    value={societyObj.bvn}
                                    style={{ width: '256px', marginTop: '10px', marginBottom: '10px' }}
                                    onChange={this.handleChangeValue('bvn')}
                                />
                                <TextField
                                    label={i18n.t('Email Address')}
                                    value={societyObj.kontakt_mejl}
                                    required
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    style={{ width: '256px', marginTop: '10px', marginBottom: '10px' }}
                                    onChange={this.handleChangeValue('kontakt_mejl')}
                                />
                                <Card raised style={styles.card}>
                                    <h2 style={{ width: '100%', alignSelf: 'center', display: 'flex', justifyContent: 'center' }}>{i18n.t('Residental Address')}</h2>
                                    <TextField
                                        label={i18n.t('Street name')}
                                        value={societyObj.ulica_i_broj_korisnik}
                                        required
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        style={{ width: '256px', marginTop: '10px', marginBottom: '10px' }}
                                        onChange={this.handleChangeValue('ulica_i_broj_korisnik')}
                                    />

                                    <TextField
                                        select
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        label={i18n.t('City/Town')}
                                        value={societyObj.id_katastarska_opstina_korisnik}
                                        required
                                        onChange={this.handleChangeValue('id_katastarska_opstina_korisnik')}
                                        SelectProps={{
                                            native: true,
                                        }}
                                        margin="normal"
                                        style={{ width: '256px', marginTop: '10px', marginBottom: '10px' }}

                                    >

                                        <option value='' />
                                        {localGovermentsArray}
                                    </TextField>
                                    <TextField
                                        select
                                        label={i18n.t('State')}
                                        value={societyObj.id_opstina_korisnik}
                                        required
                                        disabled
                                        onChange={this.handleChangeValue('id_opstina_korisnik')}
                                        SelectProps={{
                                            native: true,
                                        }}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        margin="normal"
                                        style={{ width: '256px', marginTop: '10px', marginBottom: '10px' }}

                                    >

                                        <option value='' />
                                        {statesArray}
                                    </TextField>
                                </Card>
                                <TextField
                                    label={i18n.t('Agric Value Chain i.e. rice, maize, etc.')}
                                    multiline
                                    fullWidth
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    id="full-width"
                                    margin="normal"
                                    style={{ marginTop: '10px', marginBottom: '10px' }}
                                    value={societyObj.commercial_activity}
                                    onChange={this.handleChangeValue('commercial_activity')}
                                />
                                <TextField
                                    label={i18n.t('Number of Years in the Business')}
                                    value={societyObj.num_years_business}
                                    required
                                    type="number"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    style={{ width: '256px', marginTop: '10px', marginBottom: '10px' }}
                                    onChange={this.handleChangeValue('num_years_business')}
                                />
                                <DatePicker
                                    keyboard
                                    label={i18n.t('Date of Registration')}
                                    format="DD.MM.YYYY"
                                    disableOpenOnEnter
                                    value={societyObj.incorporation_date ? moment(societyObj.incorporation_date, 'DD.MM.YYYY') :  moment(new Date, 'DD.MM.YYYY').format('DD.MM.YYYY')}
                                    style={{ width: '256px', marginTop: '10px', marginBottom: '10px' }}
                                    onChange={this.handleDateChange('incorporation_date')}
                                    labelFunc={this.renderLabel}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    animateYearScrolling={false}
                                />
                                <Card raised style={styles.card}>
                                    <h2 style={{ width: '100%', alignSelf: 'center', display: 'flex', justifyContent: 'center' }}>{i18n.t('Business Address')}</h2>
                                    <TextField
                                        label={i18n.t('Street name')}
                                        value={societyObj.ulica_i_broj}
                                        required
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        style={{ width: '256px', marginTop: '10px', marginBottom: '10px' }}
                                        onChange={this.handleChangeValue('ulica_i_broj')}
                                    />

                                    <TextField
                                        select
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        label={i18n.t('City/Town')}
                                        value={societyObj.id_katastarska_opstina}
                                        required
                                        onChange={this.handleChangeValue('id_katastarska_opstina')}
                                        SelectProps={{
                                            native: true,
                                        }}
                                        margin="normal"
                                        style={{ width: '256px', marginTop: '10px', marginBottom: '10px' }}

                                    >

                                        <option value='' />
                                        {localGovermentsArray}
                                    </TextField>
                                    <TextField
                                        select
                                        label={i18n.t('State')}
                                        value={societyObj.id_opstina}
                                        required
                                        disabled
                                        onChange={this.handleChangeValue('id_opstina')}
                                        SelectProps={{
                                            native: true,
                                        }}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        margin="normal"
                                        style={{ width: '256px', marginTop: '10px', marginBottom: '10px' }}

                                    >

                                        <option value='' />
                                        {statesArray}
                                    </TextField>
                                </Card>
                                <Grid item xs={12}>
                                    <Button
                                        style={{ alignSelf: 'center', backgroundColor: '#61a50e', color: 'white' }}
                                        onClick={() => this.addSociety()}
                                    >
                                        {i18n.t('Add')}
                                    </Button>
                                </Grid>
                            </Grid>
                        </form>
                    </DialogContent>
                </Dialog>
            </div>

        )
    }
};

function mapStateToProps(state) {
    return {
        states: state.administrationReducer.states,
        statesFetching: state.administrationReducer.statesFetching,
        societyObj: state.administrationReducer.societyObj,
        statesFetchingFailed: state.administrationReducer.statesFetchingFailed,
        societyPostingFailed: state.administrationReducer.societyPostingFailed,
        localGoverments: state.farmRegistarReducer.localGoverments,
        localGovermentsFetching: state.farmRegistarReducer.localGovermentsFetching,
        localGovermentsFetchingFailed: state.farmRegistarReducer.localGovermentsFetchingFailed,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getStates: () => dispatch(getStates()),
        getLocalGov: (id_state) => dispatch(getLocalGov(id_state)),
        setInitialState: (component) => dispatch(setInitialState(component)),
        addSociety: (societyObj) => dispatch(addSociety(societyObj)),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddSociety)